import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'
import apiClient from './apiClient'
import { ACCESS_KEY } from './internshipRequestPortal'

export const RequesterActions = Object.freeze({
  ALLOW: 'ALLOW',
  REDIRECT_TO_LOGIN: 'REDIRECT_TO_LOGIN',
  CONFIRM_SCHOOL: 'CONFIRM_SCHOOL',
  ACTIVATION_PENDING: 'ACTIVATION_PENDING'
})

export const SUBMIT_ERROR_PREFIX = 'school_portal.submit.error'

export const SCHOOL_ALREADY_EXISTS = 'SCHOOL_ALREADY_EXISTS'

export const submitSchoolPortalRequest = (body = {}) => apiClient.post(null, 'public/school-internship-requests', body)

export const checkRequesterEmail = (email, portalAccessKey, addressee = {}) => apiClient.get(
  null,
  'public/school-portal/requester-check',
  { ...addressee, email, [ACCESS_KEY]: portalAccessKey }
)

export const getSchoolPortalRequestByToken = token => apiClient.get(
  null,
  `api/internal-tokens/${token}/school-internship-request`
)

export const getAllSchoolPortalRequests = (user, parameters = {}) => apiClient.get(
  user,
  'api/school-internship-requests',
  parameters
)

export const acceptSchoolPortalRequest = (user, schoolPortalRequest, requests) => apiClient.post(
  user,
  `api/school-internship-requests/${getIdOrNull(schoolPortalRequest)}/accept`,
  { requests }
)

export const refuseSchoolPortalRequest = (user, schoolPortalRequest, refusalReason = '') => {
  return requestWithPromise(
    `/api/school-internship-requests/${getIdOrNull(schoolPortalRequest)}/refuse?refusalReason=${encodeURIComponent(refusalReason)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}
